export const APP_PATHS = {
  AUTH: 'auth',
  LOGIN: 'log-in',
  SIGNUP: 'sign-up',
} as const;

export const APP_FULL_PATHS = {
  BASE: '/',
  AUTH: '/auth',
  LOGIN: '/auth/log-in',
  SIGNUP: '/auth/sign-up',
} as const;
